import * as React from "react";
import * as ReactDOM from "react-dom";
import { useFormikContext, Field, Form, Formik, FormikProps, FormikTouched } from 'formik';
import { WorkStatus, HomeStatus, CivilStatus } from "./applicationEnums"
import { useSpring, animated } from 'react-spring';
import MaskedInput from 'react-text-mask'


const CoApp: React.FunctionComponent = () => {
    const { values, setFieldValue, errors, touched, handleChange, handleBlur } = useFormikContext<any>();
    const spring = useSpring({ opacity: 1, from: { opacity: 0 } })
    return (
        <animated.div style={spring} className="col-12 row coapp">
            <div className="form-group col-lg-6">
                <label htmlFor="partnerEmail" className="col-lg-12 control-label">E-postadress</label>
                {!errors.partnerEmail && touched.partnerEmail && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <input name="partnerEmail" id="partnerEmail" onBlur={handleBlur} className={errors.partnerEmail && touched.partnerEmail ? "text-input error" : "text-input"} onChange={handleChange} placeholder="E-postadress" />
                <div className="error-container">
                    {errors.partnerEmail && touched.partnerEmail && (<div className="text-danger">{errors.partnerEmail}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerPhoneNumber" className="col-lg-12 control-label">Mobilnummer</label>
                {!errors.partnerPhoneNumber && touched.partnerPhoneNumber && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <input name="partnerPhoneNumber" id="partnerPhoneNumber" onBlur={handleBlur} className={errors.partnerPhoneNumber && touched.partnerPhoneNumber ? "text-input error" : "text-input"} onChange={handleChange} placeholder="07 XXXX XXXX" />
                <div className="error-container">
                    {errors.partnerPhoneNumber && touched.partnerPhoneNumber && (<div className="text-danger">{errors.partnerPhoneNumber}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerIdNumber" className="col-lg-12 control-label">Personnummer</label>
                {!errors.partnerIdNumber && touched.partnerIdNumber && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <MaskedInput
                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    className={errors.partnerIdNumber && touched.partnerIdNumber ? "text-input error" : "text-input"}
                    placeholder="ÅÅÅÅMMDD-XXXX"
                    type="text"
                    id="partnerIdNumber"
                    name="partnerIdNumber"
                    value={values.partnerIdNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                <div className="error-container">
                    {errors.partnerIdNumber && touched.partnerIdNumber && (<div className="text-danger">{errors.partnerIdNumber}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerWorkStatus" className="col-lg-12 control-label">Anställningsform</label>
                <select
                    name="partnerWorkStatus"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.partnerWorkStatus && touched.partnerWorkStatus ? "select-input error" : "select-input"}
                    defaultValue=""
                >
                    <option value="" disabled hidden>- Välj -</option>
                    <option value={WorkStatus[WorkStatus.employed]}>Fast anställd</option>
                    <option value={WorkStatus[WorkStatus.selfemployed]}>Egenföretagare</option>
                    <option value={WorkStatus[WorkStatus.temporaryEmployment]}>Tidsbegränsad anställning</option>
                    <option value={WorkStatus[WorkStatus.hourlyEmployment]}>Timanställd</option>
                    <option value={WorkStatus[WorkStatus.retired]}>Pensionerad</option>
                    <option value={WorkStatus[WorkStatus.earlyRetirement]}>Förtidspensionerad</option>
                </select>
                <div className="error-container">
                    {errors.partnerWorkStatus && touched.partnerWorkStatus && (<div className="text-danger">{errors.partnerWorkStatus}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerWorkStatusSince" className="col-lg-12 control-label">Anställd sedan</label>
                {!errors.partnerWorkStatusSince && touched.partnerWorkStatusSince && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <input type="date" max={new Date().toISOString().substring(0, 10)} onBlur={handleBlur} name="partnerWorkStatusSince" id="partnerWorkStatusSince" className={errors.partnerWorkStatusSince && touched.partnerWorkStatusSince ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                <div className="error-container">
                    {errors.partnerWorkStatusSince && touched.partnerWorkStatusSince && (<div className="text-danger">{errors.partnerWorkStatusSince}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerIncome" className="col-lg-12 control-label">Månadsinkomst före skatt.</label>
                {!errors.partnerIncome && touched.partnerIncome && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <input type="number" name="partnerIncome" id="partnerIncome" min="10000" max="200000" onBlur={handleBlur} className={errors.partnerIncome && touched.partnerIncome ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                <div className="error-container">
                    {errors.partnerIncome && touched.partnerIncome && (<div className="text-danger">{errors.partnerIncome}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerLivingCost" className="col-g-12 control-label">Boendekostnad/mån</label>
                {!errors.partnerLivingCost && touched.partnerLivingCost && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <input type="number" name="partnerLivingCost" id="partnerLivingCost" min="0" max="20000" onBlur={handleBlur} className={errors.partnerLivingCost && touched.partnerLivingCost ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                <div className="error-container">
                    {errors.partnerLivingCost && touched.partnerLivingCost && (<div className="text-danger">{errors.partnerLivingCost}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerHomeStatus" className="col-g-12 control-label">Boendeform</label>
                {!errors.partnerHomeStatus && touched.partnerHomeStatus && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <select
                    name="partnerHomeStatus"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.partnerHomeStatus && touched.partnerHomeStatus ? "select-input error" : "select-input"}
                    defaultValue=""
                >
                    <option value="" disabled hidden>- Välj -</option>
                    <option value={HomeStatus[HomeStatus.rented]}>Hyresrätt</option>
                    <option value={HomeStatus[HomeStatus.house]}>Hus</option>
                    <option value={HomeStatus[HomeStatus.apartment]}>Lägenhet</option>
                    <option value={HomeStatus[HomeStatus.roommate]}>Rumskamrat</option>
                    <option value={HomeStatus[HomeStatus.parents]}>Föräldrar</option>
                </select>
                <div className="error-container">
                    {errors.partnerHomeStatus && touched.partnerHomeStatus && (<div className="text-danger">{errors.partnerHomeStatus}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="civilStatus" className="col-lg-12 control-label">Civilstånd</label>
                {!errors.partnerCivilStatus && touched.partnerCivilStatus && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <select
                    name="partnerCivilStatus"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.partnerCivilStatus && touched.partnerCivilStatus ? "select-input error" : "select-input"}
                    defaultValue=""
                >
                    <option value="" disabled hidden>- Välj -</option>
                    <option value={CivilStatus[CivilStatus.married]}>Gift</option>
                    <option value={CivilStatus[CivilStatus.single]}>Singel</option>
                    <option value={CivilStatus[CivilStatus.partner]}>Sambo</option>
                </select>
                <div className="error-container">
                    {errors.partnerCivilStatus && touched.partnerCivilStatus && (<div className="text-danger">{errors.partnerCivilStatus}</div>)}</div>
            </div>
            <div className="form-group col-lg-6">
                <label htmlFor="partnerChildren" className="col-lg-12 control-label">Antal barn</label>
                {!errors.partnerChildren && touched.partnerChildren && <span className="input-valid "><img src="/images/check.svg" /></span>}
                <input type="number" name="partnerChildren" id="partnerChildren" min="0" onBlur={handleBlur} className={errors.partnerChildren && touched.partnerChildren ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                <div className="error-container">
                    {errors.partnerChildren && touched.partnerChildren && (<div className="text-danger">{errors.partnerChildren}</div>)}</div>
            </div>
            {values.partnerWorkStatus != "retired" && values.partnerWorkStatus != "earlyRetirement" && values.partnerWorkStatus != null &&

                <div className="form-group col-lg-6">
                    <label htmlFor="partnerEmployer" className="col-lg-12 control-label">Arbetsgivare</label>
                    {!errors.partnerEmployer && touched.partnerEmployer && <span className="input-valid "><img src="/images/check.svg" /></span>}
                    <input name="partnerEmployer" id="partnerEmployer" onBlur={handleBlur} className={errors.partnerEmployer && touched.partnerEmployer ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                    <div className="error-container">
                        {errors.partnerEmployer && touched.partnerEmployer && (<div className="text-danger">{errors.partnerEmployer}</div>)}</div>
                </div>


            }
            {values.partnerWorkStatus != "retired" && values.partnerWorkStatus != "earlyRetirement" && values.partnerWorkStatus != null &&

                <div className="form-group col-lg-6">
                    <label htmlFor="partnerEmployerPhone" className="col-lg-12 control-label">Arbetsgivarens telefonnummer</label>
                    {!errors.partnerEmployerPhone && touched.partnerEmployerPhone && <span className="input-valid "><img src="/images/check.svg" /></span>}
                    <input name="partnerEmployerPhone" id="partnerEmployerPhone" onBlur={handleBlur} className={errors.partnerEmployerPhone && touched.partnerEmployerPhone ? "text-input error" : "text-input"} onChange={handleChange} placeholder=" " />
                    <div className="error-container">
                        {errors.partnerEmployerPhone && touched.partnerEmployerPhone && (<div className="text-danger">{errors.partnerEmployerPhone}</div>)}</div>
                </div>


            }
        </animated.div>
    )
}

export default CoApp;